import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';
import {HotspotCreatorService} from "../../../../service/http/hotspot-creator.service";
import {HotspotDotLink} from "../../../../model/HotspotDotLink";
import {catchError, switchMap, map} from "rxjs/operators";
import {of as observableOf} from "rxjs";
import {MessageDialogComponent} from "../../../../dialog/message-dialog/message-dialog.component";
import {FileuploadService} from "../../../../service/http/fileupload.service";

@Component({
  selector: 'app-add-hotspot-dot-dialog',
  templateUrl: './add-hotspot-dot-dialog.component.html',
  styleUrls: ['./add-hotspot-dot-dialog.component.css']
})
export class AddHotspotDotDialogComponent implements OnInit {

  currentPackageIdGlobal: any;
  isLoadingResults: boolean = true;
  treeData: HotspotDotLink[];

  treeControl = new NestedTreeControl<HotspotDotLink>(node => node.children);
  dataSource = new MatTreeNestedDataSource<HotspotDotLink>();

  dotLabelFormControl = new FormControl('', [
    Validators.required
  ]);

  dotLinkRefFormControl = new FormControl('', [
    Validators.required
  ]);

  public dotFormGroup = new FormGroup({
    dotLabel: this.dotLabelFormControl,
    dotLinkRef: this.dotLinkRefFormControl});

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<AddHotspotDotDialogComponent>,
              private hotspotCreatorService: HotspotCreatorService,
              private uploadService: FileuploadService,
              public dialog: MatDialog) {

    let currentPackageId = sessionStorage.getItem('currentPackageId');
    if(currentPackageId !== null) {
      this.currentPackageIdGlobal = currentPackageId;
    }

    this.hotspotCreatorService.getHotspotDotLinks(this.currentPackageIdGlobal)
      .pipe(
        catchError((error) => {
          this.isLoadingResults = true;
          if(error.status == 404) {
            this.isLoadingResults = false;

            console.log('404 ERROR');
            let errorDialog = this.dialog.open(MessageDialogComponent, {
              data: {   type: '', title: 'Could not load data!', message: 'Invalid XML file, or no XML file provided', secondMsg: error.error.file}
            });

            errorDialog.afterClosed().subscribe(result => {
              this.dialogRef.close();
            });

            return observableOf([]);
          } else {
            console.log('-NO- 404 ERROR');
            return observableOf([]);
          }

        }))
      .subscribe(data => {
        this.treeData = data;
        this.dataSource.data = data;
        this.treeControl.dataNodes = data;
        this.isLoadingResults = false;
      });
  }

  ngOnInit() {}

  selectedLink: HotspotDotLink = new HotspotDotLink("","", "","", "");

  hasChild = (_: number, node: HotspotDotLink) => !!node.children && node.children.length > 0;

  addDot() {
    if(this.dotFormGroup.valid) {
      let hotspotDotLabel = this.dotFormGroup.get('dotLabel').value;
      let hotspotDotLinkRef = this.dotFormGroup.get('dotLinkRef').value.id;

      //TODO, temporary fix due to toc.json, which has not for each link a target at the moment
      let hotspotDotLinkTarget = '';
      if (this.selectedLink.link != null){
        hotspotDotLinkTarget = this.selectedLink.link;
      } else {
        hotspotDotLinkTarget = 'dm/';
      }

      this.hotspotCreatorService.addDotToHotspotImage(this.currentPackageIdGlobal, this.data["hotspotId"],
        {'dot-label': hotspotDotLabel, "link-ref": hotspotDotLinkRef, "link-base-id": this.selectedLink.baseId, "link-target": hotspotDotLinkTarget, "x": 100.001, "y": 100.001})
        .subscribe();

      this.dialogRef.close();
    }
  }

  static copy(o) {
    return Object.assign({}, o)
  }

  filter(search) {

    let filteredTreeData: HotspotDotLink[];
    if (search) {

      filteredTreeData = this.treeData.map(element => AddHotspotDotDialogComponent.copy(element)).filter(function f(o) {

        if (o.children) {
          return (o.children = o.children.map(element => AddHotspotDotDialogComponent.copy(element)).filter(f)).length
        }
        return o.title.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1;
      });

      this.dataSource.data = filteredTreeData;
      this.treeControl.dataNodes = filteredTreeData;

    } else {
      this.dataSource.data = this.treeData;
      this.treeControl.dataNodes = this.treeData;
    }

    if(search) {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }
  }

}
